{
  "version": 1,
  "asset_id": "c63bf8c5-a6f4-44f1-83e3-cd1bcfef210e",
  "project_id": "949ac23c-9e33-4376-b191-e19499cf4fa3",
  "url": "/__l5e/assets-v1/c63bf8c5-a6f4-44f1-83e3-cd1bcfef210e/silivri-hizli-elektrikci-7-24-dukkan-9.jpg",
  "r2_key": "a/v1/949ac23c-9e33-4376-b191-e19499cf4fa3/c63bf8c5-a6f4-44f1-83e3-cd1bcfef210e/silivri-hizli-elektrikci-7-24-dukkan-9.jpg",
  "original_filename": "silivri-hizli-elektrikci-7-24-dukkan-9.jpg",
  "size": 138886,
  "content_type": "image/jpeg",
  "created_at": "2026-09-20T08:27:03Z"
}
